// extracted by mini-css-extract-plugin
export default {"tabPage":"tab_page_tabPage__4NDKK","title":"tab_page_title__6Knyh","description":"tab_page_description__BGUo8"};